import { createFileRoute } from "@tanstack/react-router"

import { IllustratedState } from "../../../components/IllustratedState"
import { ErrorState } from "./-Error"
import { Octopus } from "./-Octopus"

const RouteComponent = () => {
  return (
    <IllustratedState
      title="The data octopus is still plugging things in"
      description="Sources are being wired up one arm at a time. Data opens once everything is connected."
    >
      <Octopus />
    </IllustratedState>
  )
}

export const Route = createFileRoute("/_chrome/data/")({
  component: RouteComponent,
  errorComponent: ErrorState,
})
